/**
 * Copyright (C) Sitevision 2002-2026, all rights reserved
 */

import $ from '@sv/jquery';
import { getPortlet, getPortlets } from './searchDomUtils';

const OPTIONS_SELECTOR = '.sv-search-portlet-settings';
const PAGING_OPTIONS_SELECTOR = '.sv-search-portlet-paging-settings';

export const registerLegacySearchEventHandling = (
  $portlets,
  fnUpdateSearchResult,
) => {
  $portlets.each((i, portlet) => {
    const formElement = portlet.querySelector('form');
    const dataset = formElement ? formElement.dataset : {};
    const $portlet = $(portlet);

    // Add legacy onclick methods for facets and sorting.
    if (formElement && dataset.updateFunctionName) {
      window[dataset.updateFunctionName] = (url) => {
        fnUpdateSearchResult($portlet, url, 'refinement');
      };
    }

    // Legacy behavior: clear placeholder-like default text on first focus.
    // Now replaced by real placeholder text.
    if (formElement && dataset.searchInputId && dataset.escapedSearchHereText) {
      const searchInput = document.getElementById(dataset.searchInputId);
      if (
        searchInput &&
        searchInput.value === dataset.escapedSearchHereText &&
        !searchInput.hasAttribute('placeholder')
      ) {
        searchInput.value = '';
        searchInput.setAttribute('placeholder', dataset.escapedSearchHereText);
      }
    }
  });
};

export const mergeLegacyPaginationSettings = ($portlet, $paging) => {
  if (!$paging) {
    $paging = getPaginationElement($portlet);
  }

  const $pagingOptions = $portlet.find(PAGING_OPTIONS_SELECTOR);
  if ($paging.length && $pagingOptions.length) {
    const options = Object.assign(
      {},
      $pagingOptions[0].dataset,
      $paging[0].dataset,
    );
    Object.assign($paging[0].dataset, options);
    $pagingOptions[0].parentNode.removeChild($pagingOptions[0]);
  }
};

export const getPaginationElement = (portlet) => {
  const $portlet = getPortlet(portlet);
  if (!$portlet.length) {
    return $();
  }

  let $paging = $portlet.find('[data-fn-sv-paging]');

  if (!$paging.length) {
    const $formEl = $portlet.find('form');
    if ($formEl.length && $formEl.data('pagingDivClass')) {
      $paging = $portlet.find(`.${$formEl.data('pagingDivClass')}`);
    }
    if ($paging.length) {
      $paging[0].setAttribute('data-fn-sv-paging', 'true');
    }
  }

  return $paging;
};

export const normalizeLegacyMarkup = (selector) => {
  // Normalize legacy markup by moving settings data-* onto the form.

  const $portlets = getPortlets(selector);

  $portlets.each((i, portlet) => {
    const $portlet = $(portlet);
    const optionsEl = $portlet.find(OPTIONS_SELECTOR)[0];
    let formEl = $portlet.find('form')[0];
    if (!formEl) {
      // SV-40420
      // Vi har i tidigare versioner skapat en uppdateringsfunktion i velocity:
      // function ${updateResultFunctionName}(qry,fade)
      // Detta är nu borttaget och istället kommer det funktionsnamnet i
      // registerLegacySearchEventHandling att kopplas till
      // updateSearchResult i commonSearchFunction.js.
      // Det här skapar ett beroende till att vi faktiskt har en form-tagg.
      // Kunder kan ha gjort egna mallar som har fungerat utan form tidigare
      // så vi måste se till att det finns en form.
      formEl = document.createElement('form');
      $portlet.prepend(formEl);
    }

    if (optionsEl && formEl) {
      // Any data attributes on the form will override the
      // data attributes on the options element
      const options = Object.assign({}, optionsEl.dataset, formEl.dataset);
      Object.assign(formEl.dataset, options);
      optionsEl.parentNode.removeChild(optionsEl);
    }

    formEl.dataset.fnIsLegacyMode = 'true';

    mergeLegacyPaginationSettings($portlet);
  });
};
